import type { Meal } from "@heliopolis/schema/meal.js";
import type { CSSProperties, JSX } from "react";

const defaultImageSize = 120;

const messages = {
  "alt-photo-text": "photo here",
};

export type MealCardProps = {
  meal: Meal;
};

export default function MealCard(props: MealCardProps): JSX.Element {
  const { meal } = props;

  return (
    <div className="meal-card" style={Style.Card}>
      <div className="meal-card-photo" style={Style.Photo}>
        {meal.photoURL && (
          <img
            alt={messages["alt-photo-text"]}
            height={defaultImageSize}
            src={meal.photoURL ?? undefined}
            style={Style.Image}
            width={defaultImageSize}
          />
        )}
      </div>
      <div className="meal-card-body" style={Style.Body}>
        <header style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
          <h2 style={{ flexGrow: 1 }}>{meal.name}</h2>
          {meal.recipeURL && (
            <a href={meal.recipeURL} style={Style.Link}>
              Recipe
            </a>
          )}
        </header>
        {meal.ingredients && meal.ingredients.length > 0 && (
          <div className="meal-card-ingredients" style={Style.Ingredients}>
            {meal.ingredients
              .toSorted(alphabetically)
              .slice(0, 3)
              .map((ingredient) => (
                <span className="meal-card-ingredient" key={ingredient} style={Style.Ingredient}>
                  {ingredient}
                </span>
              ))}
          </div>
        )}
        <br />
        {meal.description && <p>{meal.description}</p>}
      </div>
    </div>
  );
}

const Style = {
  Body: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: "4px",
  },
  Card: {
    backgroundColor: "#000028",
    border: "1px solid #aaa",
    borderRadius: "16px",
    color: "#fff",
    display: "flex",
    flex: 1,
    flexDirection: "row",
    gap: "8px",
    padding: "8px",
  },
  Image: {},
  Ingredient: {
    backgroundColor: "#224",
    borderRadius: "4px",
    overflow: "clip",
    padding: "4px",
    textOverflow: "ellipsis",
    textWrap: "nowrap",
  },
  Ingredients: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "4px",
  },
  Link: {
    color: "#ddd",
  },
  Photo: {
    alignContent: "center",
    backgroundColor: "#224",
    border: "1px solid #666",
    borderRadius: "8px",
    height: `${defaultImageSize}px`,
    overflow: "clip",
    textOverflow: "ellipsis",
    maxWidth: `${defaultImageSize}px`,
    minWidth: `${defaultImageSize}px`,
    textAlign: "center",
    width: `${defaultImageSize}px`,
  },
} as const satisfies Record<string, CSSProperties>;

function alphabetically(a: string, b: string): number {
  return a.localeCompare(b);
}
